<template>
  <v-container
    fluid
    class="my-md-12 px-md-6 mx-xl-auto"
    style="max-width: 1600px"
  >
    <v-row>
      <v-col>
        <h2 class="text-md-h4 text--secondary">
          {{ $t("title.notifications") }}
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p>
          Notifications are used by either COUNTER or individual content
          providers to inform clients about important events related to a
          particular SUSHI service. These include notifications of service
          maintenance, data issues requiring data re-harvest, etc.
        </p>
        <p>
          The following list contains all registered notifications regardless of
          platform. You can also find notifications related to a particular
          platform listed on its corresponding page.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <NotificationList
          :notifications="filteredNotifications"
          :loading="loading"
          show-platform
          show-release
        >
          <template #append>
            <FiltersButton
              :count="filterBadgeCount"
              @click="areFiltersVisible = true"
            />
          </template>
        </NotificationList>
      </v-col>
    </v-row>
    <FilterDrawer v-model="areFiltersVisible" @reset="resetFilters">
      <NotificationFilters
        v-model="filters"
        :notifications="notifications"
        show-platform
        show-release
      />
    </FilterDrawer>
  </v-container>
</template>

<script>
import NotificationList from "../components/NotificationList";
import NotificationFilters from "../components/NotificationFilters";
import FilterDrawer from "../components/FilterDrawer";
import FiltersButton from "../components/FiltersButton";
import CounterAPI from "../lib/api";
import {
  activeFilterCount,
  emptyNotificationFilters,
  filterNotifications,
} from "../lib/listFilters";

export default {
  name: "NotificationsPage",

  components: {
    NotificationList,
    NotificationFilters,
    FilterDrawer,
    FiltersButton,
  },

  data() {
    return {
      areFiltersVisible: false,
      filters: emptyNotificationFilters(),
      notifications: [],
      loading: false,
      api: new CounterAPI(process.env.COUNTER_API_ROOT),
    };
  },

  computed: {
    filteredNotifications() {
      return filterNotifications(this.notifications, this.filters);
    },
    filterBadgeCount() {
      return activeFilterCount(this.filters);
    },
  },

  methods: {
    async getNotifications() {
      this.loading = true;
      try {
        this.notifications = await this.api.getAllNotifications();
      } finally {
        this.loading = false;
      }
    },
    resetFilters() {
      this.filters = emptyNotificationFilters();
    },
  },

  mounted() {
    this.getNotifications();
  },
};
</script>

<style scoped></style>
